export enum TrackingEvent {
  SelectDateRange = `Select date range`,
  SelectChart = `Select chart`,
  SelectValueRepresentation = `Select value representation`,
  SelectDateUnit = `Select date unit`,
  RemoveComparisonDateRange = `Remove comparison date range`,
}

export const CAPTURED_TRACKING = new Set<string>([`Select comparison date range`]);
